/**
 * Register actions
 */
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_RESPONSE = 'FORGOT_PASSWORD_RESPONSE';